import { LIST_ADMIN } from '../actionTypes'

export const listAdmin = (data?: object) => ({
  type: LIST_ADMIN.name,
  api: {
    url: 'guests/list_admin',
    data,
  },
})
